/**
 * V2 Index
 * 
 * Redirects to home screen.
 */

import { Redirect } from 'expo-router';

export default function V2Index() {
  return <Redirect href="/v2/home" />;
}

